import { Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

import PlaceholderImg from 'images/empty-homepage-placeholder.png'
import NewCalculationDropdown from 'views/CalculateEmissions/NewCalculationDropdown'
import { NavigationSource } from 'views/CalculateEmissions/Shared/BackButtonWithFromState'

const EmptyHomepage: FC = () => {
    return (
        <Box
            sx={{
                backgroundColor: `Surface300`,
                height: '100vh',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '900px',
                    height: '680px',
                    margin: 'auto',
                    p: 4,
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        height: '350px',
                        backgroundImage: `url("${PlaceholderImg}")`,
                        backgroundPosition: 'top',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                    }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <Text variant={'h5'} sx={{ mb: 1 }}>
                        There’s nothing to display right now
                    </Text>
                    <Text
                        variant={'body2'}
                        sx={{
                            mb: 3,
                            textAlign: 'center',
                            maxWidth: '620px',
                        }}
                    >
                        Your dashboard updates automatically based on activity from the last 30
                        days. When new data becomes available, you’ll see it appear here.
                    </Text>
                    <NewCalculationDropdown from={NavigationSource.HOMEPAGE} />
                </Box>
            </Box>
        </Box>
    )
}

export default EmptyHomepage
